/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FideleRouteRouteImport } from './routes/_fidele/route'
import { Route as PlaceurRouteRouteImport } from './routes/_placeur/route'
import { Route as StaffRouteRouteImport } from './routes/_staff/route'
import { Route as EspaceIndisponibleRouteImport } from './routes/espace-indisponible'
import { Route as HorsConnexionRouteImport } from './routes/hors-connexion'
import { Route as ConnexionIndexRouteImport } from './routes/connexion/index'
import { Route as ConnexionCodeRouteImport } from './routes/connexion/code'
import { Route as ConnexionPinRouteImport } from './routes/connexion/pin'
import { Route as FideleMesPresencesIndexRouteImport } from './routes/_fidele/mes-presences/index'
import { Route as FideleMonProfilIndexRouteImport } from './routes/_fidele/mon-profil/index'
import { Route as FideleMonQrIndexRouteImport } from './routes/_fidele/mon-qr/index'
import { Route as PlaceurScannerIndexRouteImport } from './routes/_placeur/scanner/index'
import { Route as StaffAccueilIndexRouteImport } from './routes/_staff/accueil/index'
import { Route as StaffCultesIndexRouteImport } from './routes/_staff/cultes/index'
import { Route as StaffFinancesIndexRouteImport } from './routes/_staff/finances/index'
import { Route as StaffMembresIndexRouteImport } from './routes/_staff/membres/index'
import { Route as StaffProfilIndexRouteImport } from './routes/_staff/profil/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FideleRouteRoute = FideleRouteRouteImport.update({
  id: '/_fidele',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaceurRouteRoute = PlaceurRouteRouteImport.update({
  id: '/_placeur',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRouteRoute = StaffRouteRouteImport.update({
  id: '/_staff',
  getParentRoute: () => rootRouteImport,
} as any)
const EspaceIndisponibleRoute = EspaceIndisponibleRouteImport.update({
  id: '/espace-indisponible',
  path: '/espace-indisponible',
  getParentRoute: () => rootRouteImport,
} as any)
const HorsConnexionRoute = HorsConnexionRouteImport.update({
  id: '/hors-connexion',
  path: '/hors-connexion',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnexionIndexRoute = ConnexionIndexRouteImport.update({
  id: '/connexion/',
  path: '/connexion/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnexionCodeRoute = ConnexionCodeRouteImport.update({
  id: '/connexion/code',
  path: '/connexion/code',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnexionPinRoute = ConnexionPinRouteImport.update({
  id: '/connexion/pin',
  path: '/connexion/pin',
  getParentRoute: () => rootRouteImport,
} as any)
const FideleMesPresencesIndexRoute = FideleMesPresencesIndexRouteImport.update({
  id: '/mes-presences/',
  path: '/mes-presences/',
  getParentRoute: () => FideleRouteRoute,
} as any)
const FideleMonProfilIndexRoute = FideleMonProfilIndexRouteImport.update({
  id: '/mon-profil/',
  path: '/mon-profil/',
  getParentRoute: () => FideleRouteRoute,
} as any)
const FideleMonQrIndexRoute = FideleMonQrIndexRouteImport.update({
  id: '/mon-qr/',
  path: '/mon-qr/',
  getParentRoute: () => FideleRouteRoute,
} as any)
const PlaceurScannerIndexRoute = PlaceurScannerIndexRouteImport.update({
  id: '/scanner/',
  path: '/scanner/',
  getParentRoute: () => PlaceurRouteRoute,
} as any)
const StaffAccueilIndexRoute = StaffAccueilIndexRouteImport.update({
  id: '/accueil/',
  path: '/accueil/',
  getParentRoute: () => StaffRouteRoute,
} as any)
const StaffCultesIndexRoute = StaffCultesIndexRouteImport.update({
  id: '/cultes/',
  path: '/cultes/',
  getParentRoute: () => StaffRouteRoute,
} as any)
const StaffFinancesIndexRoute = StaffFinancesIndexRouteImport.update({
  id: '/finances/',
  path: '/finances/',
  getParentRoute: () => StaffRouteRoute,
} as any)
const StaffMembresIndexRoute = StaffMembresIndexRouteImport.update({
  id: '/membres/',
  path: '/membres/',
  getParentRoute: () => StaffRouteRoute,
} as any)
const StaffProfilIndexRoute = StaffProfilIndexRouteImport.update({
  id: '/profil/',
  path: '/profil/',
  getParentRoute: () => StaffRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/espace-indisponible': typeof EspaceIndisponibleRoute
  '/hors-connexion': typeof HorsConnexionRoute
  '/connexion/code': typeof ConnexionCodeRoute
  '/connexion/pin': typeof ConnexionPinRoute
  '/connexion/': typeof ConnexionIndexRoute
  '/mes-presences/': typeof FideleMesPresencesIndexRoute
  '/mon-profil/': typeof FideleMonProfilIndexRoute
  '/mon-qr/': typeof FideleMonQrIndexRoute
  '/scanner/': typeof PlaceurScannerIndexRoute
  '/accueil/': typeof StaffAccueilIndexRoute
  '/cultes/': typeof StaffCultesIndexRoute
  '/finances/': typeof StaffFinancesIndexRoute
  '/membres/': typeof StaffMembresIndexRoute
  '/profil/': typeof StaffProfilIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/espace-indisponible': typeof EspaceIndisponibleRoute
  '/hors-connexion': typeof HorsConnexionRoute
  '/connexion/code': typeof ConnexionCodeRoute
  '/connexion/pin': typeof ConnexionPinRoute
  '/connexion': typeof ConnexionIndexRoute
  '/mes-presences': typeof FideleMesPresencesIndexRoute
  '/mon-profil': typeof FideleMonProfilIndexRoute
  '/mon-qr': typeof FideleMonQrIndexRoute
  '/scanner': typeof PlaceurScannerIndexRoute
  '/accueil': typeof StaffAccueilIndexRoute
  '/cultes': typeof StaffCultesIndexRoute
  '/finances': typeof StaffFinancesIndexRoute
  '/membres': typeof StaffMembresIndexRoute
  '/profil': typeof StaffProfilIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_fidele': typeof FideleRouteRouteWithChildren
  '/_placeur': typeof PlaceurRouteRouteWithChildren
  '/_staff': typeof StaffRouteRouteWithChildren
  '/espace-indisponible': typeof EspaceIndisponibleRoute
  '/hors-connexion': typeof HorsConnexionRoute
  '/connexion/code': typeof ConnexionCodeRoute
  '/connexion/pin': typeof ConnexionPinRoute
  '/connexion/': typeof ConnexionIndexRoute
  '/_fidele/mes-presences/': typeof FideleMesPresencesIndexRoute
  '/_fidele/mon-profil/': typeof FideleMonProfilIndexRoute
  '/_fidele/mon-qr/': typeof FideleMonQrIndexRoute
  '/_placeur/scanner/': typeof PlaceurScannerIndexRoute
  '/_staff/accueil/': typeof StaffAccueilIndexRoute
  '/_staff/cultes/': typeof StaffCultesIndexRoute
  '/_staff/finances/': typeof StaffFinancesIndexRoute
  '/_staff/membres/': typeof StaffMembresIndexRoute
  '/_staff/profil/': typeof StaffProfilIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/espace-indisponible'
    | '/hors-connexion'
    | '/connexion/code'
    | '/connexion/pin'
    | '/connexion/'
    | '/mes-presences/'
    | '/mon-profil/'
    | '/mon-qr/'
    | '/scanner/'
    | '/accueil/'
    | '/cultes/'
    | '/finances/'
    | '/membres/'
    | '/profil/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/espace-indisponible'
    | '/hors-connexion'
    | '/connexion/code'
    | '/connexion/pin'
    | '/connexion'
    | '/mes-presences'
    | '/mon-profil'
    | '/mon-qr'
    | '/scanner'
    | '/accueil'
    | '/cultes'
    | '/finances'
    | '/membres'
    | '/profil'
  id:
    | '__root__'
    | '/'
    | '/_fidele'
    | '/_placeur'
    | '/_staff'
    | '/espace-indisponible'
    | '/hors-connexion'
    | '/connexion/code'
    | '/connexion/pin'
    | '/connexion/'
    | '/_fidele/mes-presences/'
    | '/_fidele/mon-profil/'
    | '/_fidele/mon-qr/'
    | '/_placeur/scanner/'
    | '/_staff/accueil/'
    | '/_staff/cultes/'
    | '/_staff/finances/'
    | '/_staff/membres/'
    | '/_staff/profil/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FideleRouteRoute: typeof FideleRouteRouteWithChildren
  PlaceurRouteRoute: typeof PlaceurRouteRouteWithChildren
  StaffRouteRoute: typeof StaffRouteRouteWithChildren
  EspaceIndisponibleRoute: typeof EspaceIndisponibleRoute
  HorsConnexionRoute: typeof HorsConnexionRoute
  ConnexionCodeRoute: typeof ConnexionCodeRoute
  ConnexionPinRoute: typeof ConnexionPinRoute
  ConnexionIndexRoute: typeof ConnexionIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_fidele': {
      id: '/_fidele'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof FideleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_placeur': {
      id: '/_placeur'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PlaceurRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaffRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/espace-indisponible': {
      id: '/espace-indisponible'
      path: '/espace-indisponible'
      fullPath: '/espace-indisponible'
      preLoaderRoute: typeof EspaceIndisponibleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hors-connexion': {
      id: '/hors-connexion'
      path: '/hors-connexion'
      fullPath: '/hors-connexion'
      preLoaderRoute: typeof HorsConnexionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connexion/': {
      id: '/connexion/'
      path: '/connexion'
      fullPath: '/connexion/'
      preLoaderRoute: typeof ConnexionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connexion/code': {
      id: '/connexion/code'
      path: '/connexion/code'
      fullPath: '/connexion/code'
      preLoaderRoute: typeof ConnexionCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connexion/pin': {
      id: '/connexion/pin'
      path: '/connexion/pin'
      fullPath: '/connexion/pin'
      preLoaderRoute: typeof ConnexionPinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_fidele/mes-presences/': {
      id: '/_fidele/mes-presences/'
      path: '/mes-presences'
      fullPath: '/mes-presences/'
      preLoaderRoute: typeof FideleMesPresencesIndexRouteImport
      parentRoute: typeof FideleRouteRoute
    }
    '/_fidele/mon-profil/': {
      id: '/_fidele/mon-profil/'
      path: '/mon-profil'
      fullPath: '/mon-profil/'
      preLoaderRoute: typeof FideleMonProfilIndexRouteImport
      parentRoute: typeof FideleRouteRoute
    }
    '/_fidele/mon-qr/': {
      id: '/_fidele/mon-qr/'
      path: '/mon-qr'
      fullPath: '/mon-qr/'
      preLoaderRoute: typeof FideleMonQrIndexRouteImport
      parentRoute: typeof FideleRouteRoute
    }
    '/_placeur/scanner/': {
      id: '/_placeur/scanner/'
      path: '/scanner'
      fullPath: '/scanner/'
      preLoaderRoute: typeof PlaceurScannerIndexRouteImport
      parentRoute: typeof PlaceurRouteRoute
    }
    '/_staff/accueil/': {
      id: '/_staff/accueil/'
      path: '/accueil'
      fullPath: '/accueil/'
      preLoaderRoute: typeof StaffAccueilIndexRouteImport
      parentRoute: typeof StaffRouteRoute
    }
    '/_staff/cultes/': {
      id: '/_staff/cultes/'
      path: '/cultes'
      fullPath: '/cultes/'
      preLoaderRoute: typeof StaffCultesIndexRouteImport
      parentRoute: typeof StaffRouteRoute
    }
    '/_staff/finances/': {
      id: '/_staff/finances/'
      path: '/finances'
      fullPath: '/finances/'
      preLoaderRoute: typeof StaffFinancesIndexRouteImport
      parentRoute: typeof StaffRouteRoute
    }
    '/_staff/membres/': {
      id: '/_staff/membres/'
      path: '/membres'
      fullPath: '/membres/'
      preLoaderRoute: typeof StaffMembresIndexRouteImport
      parentRoute: typeof StaffRouteRoute
    }
    '/_staff/profil/': {
      id: '/_staff/profil/'
      path: '/profil'
      fullPath: '/profil/'
      preLoaderRoute: typeof StaffProfilIndexRouteImport
      parentRoute: typeof StaffRouteRoute
    }
  }
}

interface FideleRouteRouteChildren {
  FideleMesPresencesIndexRoute: typeof FideleMesPresencesIndexRoute
  FideleMonProfilIndexRoute: typeof FideleMonProfilIndexRoute
  FideleMonQrIndexRoute: typeof FideleMonQrIndexRoute
}

const FideleRouteRouteChildren: FideleRouteRouteChildren = {
  FideleMesPresencesIndexRoute: FideleMesPresencesIndexRoute,
  FideleMonProfilIndexRoute: FideleMonProfilIndexRoute,
  FideleMonQrIndexRoute: FideleMonQrIndexRoute,
}

const FideleRouteRouteWithChildren = FideleRouteRoute._addFileChildren(
  FideleRouteRouteChildren,
)

interface PlaceurRouteRouteChildren {
  PlaceurScannerIndexRoute: typeof PlaceurScannerIndexRoute
}

const PlaceurRouteRouteChildren: PlaceurRouteRouteChildren = {
  PlaceurScannerIndexRoute: PlaceurScannerIndexRoute,
}

const PlaceurRouteRouteWithChildren = PlaceurRouteRoute._addFileChildren(
  PlaceurRouteRouteChildren,
)

interface StaffRouteRouteChildren {
  StaffAccueilIndexRoute: typeof StaffAccueilIndexRoute
  StaffCultesIndexRoute: typeof StaffCultesIndexRoute
  StaffFinancesIndexRoute: typeof StaffFinancesIndexRoute
  StaffMembresIndexRoute: typeof StaffMembresIndexRoute
  StaffProfilIndexRoute: typeof StaffProfilIndexRoute
}

const StaffRouteRouteChildren: StaffRouteRouteChildren = {
  StaffAccueilIndexRoute: StaffAccueilIndexRoute,
  StaffCultesIndexRoute: StaffCultesIndexRoute,
  StaffFinancesIndexRoute: StaffFinancesIndexRoute,
  StaffMembresIndexRoute: StaffMembresIndexRoute,
  StaffProfilIndexRoute: StaffProfilIndexRoute,
}

const StaffRouteRouteWithChildren = StaffRouteRoute._addFileChildren(
  StaffRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FideleRouteRoute: FideleRouteRouteWithChildren,
  PlaceurRouteRoute: PlaceurRouteRouteWithChildren,
  StaffRouteRoute: StaffRouteRouteWithChildren,
  EspaceIndisponibleRoute: EspaceIndisponibleRoute,
  HorsConnexionRoute: HorsConnexionRoute,
  ConnexionCodeRoute: ConnexionCodeRoute,
  ConnexionPinRoute: ConnexionPinRoute,
  ConnexionIndexRoute: ConnexionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
